export default "__VITE_ASSET__BrxBaV9J__"